const normalize = (value: string) => value.normalize('NFC').toLocaleLowerCase('sv-SE');

/** Case-insensitive "contains" match on company name; surrounding whitespace in the query is ignored. */
export function filterCompaniesByName<T extends { name: string }>(companies: T[], query: string): T[] {
  const needle = normalize(query.trim());
  if (!needle) return companies;
  return companies.filter((company) => normalize(company.name).includes(needle));
}
